export default {
  id: 3,
  adminOnly: false,
  type: "teachers",
  title: "Profesores",
  deleteEntriesAllowed: true,
  actions: {
    get: "getTeachers",
    post: "postTeacher",
    patch: "patchTeacher",
    delete: "deleteTeacher",
  },
  headers: [
    {
      title: "ID Instructor",
      field: {
        name: "ID_Instructor",
        type: "text",
        editable: true,
      },
    },
    {
      title: "ID Localización",
      field: {
        name: "ID_Location",
        type: "select",
        multiple: false,
        options: "locations",
        optionName: "ID_Location",
        editable: false,
      },
    },
    {
      title: "Nombre",
      field: {
        name: "nombre",
        type: "text",
        editable: true,
      },
    },
    {
      title: "Apellidos",
      field: {
        name: "apellidos",
        type: "text",
        editable: true,
      },
    },
  ],
  options: [],
  filters: [
    {
      title: "ID Instructor",
      name: "ID_Instructor",
      type: "select",
      fromExtras: true,
      options: "instructor_distinct",
      optionName: "ID_Instructor",
    },
    {
      title: "ID Localización",
      name: "ID_Location",
      type: "select",
      fromExtras: true,
      options: "locations",
      optionName: "ID_Location",
    },
    {
      title: "Nombre",
      name: "nombre",
      type: "select",
      fromExtras: true,
      options: "name_distinct",
      optionName: "nombre",
    },
    {
      title: "Apellidos",
      name: "apellidos",
      type: "select",
      fromExtras: true,
      options: "lastname_distinct",
      optionName: "apellidos",
    },
  ],
};
